import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { WageType } from './wage-type.interface';
import { WageTypeService } from './wage-type.service';

const service = new WageTypeService();

export interface WageTypeState {
   wageTypes: Array<WageType>;
}

const WageTypeStore: Module<WageTypeState, StoreState> = {
   namespaced: true,
   state: { wageTypes: [] },
   getters: {
      wageType: (state) => state.wageTypes,
   },
   mutations: {
      SET_WAGE_TYPES(state, wageTypes: Array<WageType>) {
         state.wageTypes = wageTypes;
      },
   },
   actions: {
      async getWageTypes(context, query: LocationQuery) {
         const response = await service.getWageTypes({ ...query, per_page: '9999', page: '1' });
         context.commit('SET_WAGE_TYPES', response.data);
         return response;
      },
   },
};

export default WageTypeStore;
